import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import VisibilitySensor from 'react-visibility-sensor';

import generalStyles from './style/general.module.css';

const cx = classNames.bind({ ...generalStyles });

export default class RevealWrapper extends Component {
  constructor() {
    super();

    this.handleVisibility = this.handleVisibility.bind(this);

    this.state = {
      isVisible: false,
      isActive: true,
    };
  }

  handleVisibility(isVisible) {
    this.setState({
      isVisible,
      isActive: !isVisible,
    });
  }

  render() {
    const { children } = this.props;
    const { isVisible, isActive } = this.state;

    const visibilitySensorProps = {
      onChange: this.handleVisibility,
      active: isActive, // activate visibilitySensor only once.
      partialVisibility: true,
    };

    const revealClassName = cx('revealWrapper', {
      isVisible,
    });

    return (
      <VisibilitySensor {...visibilitySensorProps}>
        <div className={revealClassName}>{children}</div>
      </VisibilitySensor>
    );
  }
}

RevealWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/wrappers/RevealWrapper/index.js